import React from 'react';
import { ScrollView, View, ViewStyle } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface CardProps {
    children?: React.ReactNode;
    style?: ViewStyle;
    scrollView?: boolean;
}

export default function Card(props: CardProps) {
    const { styles } = useStyles(stylesheet);

    if (props.scrollView) {
        return <ScrollView style={[styles.container, props.style]}>
            {props.children}
        </ScrollView>;
    }

    return <View style={[styles.container, props.style]}>
        {props.children}
    </View>;
}

const stylesheet = createStyleSheet(theme => ({
    container: {
        borderWidth: 1,
        borderRadius: 8,
        borderColor: theme.colors.dataTable.background,
        backgroundColor: theme.colors.dataTable.background,
        padding: 16,
        flex: 1,
    },
}));
